import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filterObj",
})
export class FilterObjPipe implements PipeTransform {
  transform(items: any[], field: string, value: string): any[] {
    if (!items) return [];
    if (!value || value.length == 0) return items;
    return items.filter((it) => {
      return Array.isArray(it[field])
        ? it[field].includes(value)
        : it[field].indexOf(value) != -1;
    });
  }
}
